import React from 'react';

const QrCode = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      viewBox="0 0 792 792"
    >
      <g fill={color || '#FFFFFF'}>
        <g transform="translate(240,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,48) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,72) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,72) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,72) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,72) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,72) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,72) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,96) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,120) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,144) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,168) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,168) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,168) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,192) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,216) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,216) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,216) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,216) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,216) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,216) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(72,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(96,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(120,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(144,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(216,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,240) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,264) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(72,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(144,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,288) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(72,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(144,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,312) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(96,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(216,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,336) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(72,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(120,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(216,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,360) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(96,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(120,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(144,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,384) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(96,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(120,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(144,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(216,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,408) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(96,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(120,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(144,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,432) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(72,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(168,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,456) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,480) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(96,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,504) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(120,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(192,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(216,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,528) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,552) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,576) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(720,600) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(264,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,624) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,648) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(288,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(336,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(408,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(432,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(552,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(576,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(600,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,672) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(240,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(312,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(480,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(528,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(648,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(696,696) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(360,720) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(384,720) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(456,720) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(504,720) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(624,720) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(672,720) scale(4.12)">
          <rect width="6" height="6" />
        </g>
        <g transform="translate(48,48)">
          <g transform="scale(12)">
            <path d="M0,0v14h14V0H0z M12,12H2V2h10V12z" />
          </g>
        </g>
        <g transform="translate(576,48)">
          <g transform="scale(12)">
            <path d="M0,0v14h14V0H0z M12,12H2V2h10V12z" />
          </g>
        </g>
        <g transform="translate(48,576)">
          <g transform="scale(12)">
            <path d="M0,0v14h14V0H0z M12,12H2V2h10V12z" />
          </g>
        </g>
        <g transform="translate(96,96)">
          <g transform="scale(12)">
            <rect width="6" height="6" />
          </g>
        </g>
        <g transform="translate(624,96)">
          <g transform="scale(12)">
            <rect width="6" height="6" />
          </g>
        </g>
        <g transform="translate(96,624)">
          <g transform="scale(12)">
            <rect width="6" height="6" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default QrCode;
